// User-facing version chip displayed in account-sidebar / settings footer.
// MAJOR_MINOR is bumped manually on real releases; PATCH is hours since
// 2026-01-01 of the HEAD commit timestamp, injected at build time by
// `vite.config.ts` (define block → import.meta.env.NEXT_PUBLIC_BUILD_NUMBER).
// Monotonic; works on shallow clones (Cloudflare Pages depth=1).
const MAJOR_MINOR = "0.1";
const PATCH = (import.meta.env.NEXT_PUBLIC_BUILD_NUMBER as string | undefined) ?? "0";

export const APP_VERSION = `${MAJOR_MINOR}.${PATCH}`;

/** Short commit SHA — useful in bug reports + Sentry tagging. */
export const APP_BUILD_ID = (import.meta.env.NEXT_PUBLIC_BUILD_ID as string | undefined) ?? "dev";
